import { __assign } from 'tslib';
import useSystemEnums from '../useSystemEnums/index.js';

var useStationType = function () {
    var stationTypesEnum = useSystemEnums(function (s) { return s.station_types; }) || {};
    var DC = stationTypesEnum.DC, HUB = stationTypesEnum.HUB, SP = stationTypesEnum.EXTERNAL, WH = stationTypesEnum.Warehouse, FM_HUB = stationTypesEnum["First Mile HUB"], AM_HUB = stationTypesEnum["All Mile HUB"], OPERATOR_HUB = stationTypesEnum["Operator Hub"];
    var stationTypeMapping = __assign(__assign({}, stationTypesEnum), { DC: DC, HUB: HUB, // HUB 即 LM_HUB
        FM_HUB: FM_HUB, AM_HUB: AM_HUB, SP: SP, WH: WH, OPERATOR_HUB: OPERATOR_HUB });
    return {
        stationTypesEnum: stationTypesEnum,
        stationTypeMapping: stationTypeMapping,
    };
};

export { useStationType as default };
